import React from 'react';
import MissCalibrationTable from '../../components/UI/MissedRecalibrationsTable';
import { Main, Title, Icon, TableContainer } from '../../styles/tablePages';

interface Props {
  country: string;
}

const MissCalibration: React.FC<Props> = ({ country }) => {
  const title = 'Missed Recalibrations';

  return (
    <Main>
      <Title>
        <Icon />
        <h1>{title}</h1>
      </Title>

      <TableContainer>
        <MissCalibrationTable title={title} />
      </TableContainer>
    </Main>
  );
};

export default MissCalibration;
